import { useState } from 'react';
import { Button } from 'src/components/atoms/Button';
import { CustomToast } from 'src/components/atoms/CustomToast';
import { ConfirmDialog } from 'src/components/molecules/ConfirmDialog';
import { useCustomToast } from 'src/hooks/useCustomToast';
import { useForecastingDataContext } from '../../../contexts/ForecastingDataContext';
import { useFontErrorColor } from 'src/hooks/colors/useErrorColor';

type DeleteForecastButtonProps = {
  forecastId: string;
};

export const DeleteForecastButton: React.FC<DeleteForecastButtonProps> = ({
  forecastId,
}) => {
  const { deleteForecast } = useForecastingDataContext();
  const color = useFontErrorColor();
  const { toastState, showError, hideToast } = useCustomToast();

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (deleting) return;
    setDeleting(true);
    try {
      await deleteForecast(forecastId);
    } catch {
      showError(
        'Deletion failed',
        'Failed to delete forecast. Please try again.',
      );
      setDeleting(false);
    }
  };

  const handleConfirm = () => {
    setConfirmOpen(false);
    handleDelete();
  };

  return (
    <>
      <Button
        buttonName="delete-forecast"
        isLoading={deleting}
        onClick={() => setConfirmOpen(true)}
        color={color}
        variant="outline">
        Delete
      </Button>
      <ConfirmDialog
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
        headerText="Delete Forecast"
        bodyText="Are you sure? You can't undo this action afterwards."
        confirmText="Delete"
      />
      <CustomToast
        isOpen={toastState.isOpen}
        title={toastState.title}
        description={toastState.description}
        type={toastState.type}
        onClose={hideToast}
      />
    </>
  );
};
